export class TreatmentMutationInFlightError extends Error {
  constructor(activeIntent, rejectedIntent) {
    super("Another treatment action is still in progress.");
    this.name = "TreatmentMutationInFlightError";
    this.code = "transition_in_flight";
    this.activeIntent = activeIntent;
    this.rejectedIntent = rejectedIntent;
    this.retryable = true;
  }
}

export const createTreatmentAuthorityMutationGate = () => {
  let active = null;

  return (intent, mutation) => {
    const intentKey = String(intent || "");
    if (!intentKey || typeof mutation !== "function") {
      throw new TypeError("A treatment mutation intent and function are required.");
    }
    if (active) {
      if (active.intent === intentKey) return active.promise;
      return Promise.reject(
        new TreatmentMutationInFlightError(active.intent, intentKey),
      );
    }

    const promise = Promise.resolve().then(mutation);
    active = { intent: intentKey, promise };
    const release = () => {
      if (active?.promise === promise) active = null;
    };
    promise.then(release, release);
    return promise;
  };
};
